<template>
  <v-dialog
      v-model="showEventExampleViewer"
      persistent
      max-width="600px"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">{{currentItem.title}}</span>
      </v-card-title>
      <v-card-text class="py-0">
        <div id="json-box">
          <json-viewer v-if="$helper.isJSON(currentItem.example)" copyable :value="JSON.parse(currentItem.example)">
            <template v-slot:copy="status">
              <v-icon v-if="status.copied" small>mdi-check</v-icon>
              <v-icon v-else small>mdi-content-copy</v-icon>
            </template>
          </json-viewer>
        </div>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
            depressed
            class="text-none"
            @click="showEventExampleViewer = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {sync} from "vuex-pathify";

export default {
  name: "EventExampleViewer",
  computed: {
    showEventExampleViewer: sync('dialogs/showEventExampleViewer'),
    currentItem: sync('event/currentItem')
  }
}
</script>

<style scoped lang="scss">
#json-box {
  overflow: auto;
  max-height: 300px;
  border: 1px solid #d3d3d3;
  border-radius: 8px;
}
</style>
